import React from 'react';
import { motion } from 'framer-motion';
const images = [{
  before: 'https://cdn.magicpatterns.com/uploads/qpDX6qPp5GrQW1uriJgv33/image.png',
  after: 'https://cdn.magicpatterns.com/uploads/uyAyGkhhVAJn3hZ2c4Gr3n/image.png'
}, {
  before: 'https://images.unsplash.com/photo-1556912167-45710a7156aa?auto=format&fit=crop&q=80&w=600',
  after: 'https://images.unsplash.com/photo-1588854337236-6889d631faa8?auto=format&fit=crop&q=80&w=600'
}, {
  before: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&q=80&w=600',
  after: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&q=80&w=600'
}, {
  before: 'https://images.pexels.com/photos/1080721/pexels-photo-1080721.jpeg?auto=compress&cs=tinysrgb&w=800',
  after: 'https://images.unsplash.com/photo-1588854337236-6889d631faa8?auto=format&fit=crop&q=80&w=600'
}, {
  before: 'https://cdn.magicpatterns.com/uploads/edZNPSX49DtQo72wSY6B5B/pexels-curtis-adams-1694007-3935326.jpg',
  after: 'https://images.unsplash.com/photo-1588854337236-6889d631faa8?auto=format&fit=crop&q=80&w=600'
}];
export function MarqueeGallery() {
  return <div className="bg-charcoal py-8 overflow-hidden border-y-3 border-charcoal relative" data-id="element-72">
      <div className="absolute top-0 left-0 bottom-0 w-32 bg-gradient-to-r from-charcoal to-transparent z-10" data-id="element-73" />
      <div className="absolute top-0 right-0 bottom-0 w-32 bg-gradient-to-l from-charcoal to-transparent z-10" data-id="element-74" />

      <motion.div className="flex gap-0 whitespace-nowrap" animate={{
      x: ['0%', '-50%']
    }} transition={{
      duration: 40,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-75">
        {[...images, ...images].map((img, i) => <div key={i} className="flex gap-0 items-center shrink-0" data-id="element-76">
            <div className="relative group" data-id="element-77">
              <div className="w-96 h-64 border-r border-white/10 overflow-hidden" data-id="element-78">
                <img src={img.before} alt="Before" className="w-full h-full object-cover grayscale brightness-75" data-id="element-79" />
              </div>
              <div className="absolute top-4 left-4 bg-black/60 backdrop-blur-sm text-[10px] text-white px-3 py-1 font-bold uppercase tracking-[0.2em]" data-id="element-80">
                Before
              </div>
            </div>
            <div className="relative" data-id="element-81">
              <div className="w-96 h-64 border-r border-white/10 overflow-hidden" data-id="element-82">
                <img src={img.after} alt="After" className="w-full h-full object-cover" data-id="element-83" />
              </div>
              <div className="absolute top-4 left-4 bg-[#6B0D24]/80 backdrop-blur-sm text-[10px] text-white px-3 py-1 font-bold uppercase tracking-[0.2em]" data-id="element-84">
                After
              </div>
            </div>
          </div>)}
      </motion.div>
    </div>;
}